import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { Typography } from '@mui/material';
export const RegularApr = t0 => {
  const $ = _c(3);
  const {
    creditCardOffer
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    apr: t2
  } = t1;
  const {
    ongoingRate
  } = t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "inherit"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== ongoingRate) {
    t4 = <Typography sx={t3}>{ongoingRate}</Typography>;
    $[1] = ongoingRate;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
};